import type { JSX } from "solid-js";

/** One grid, one stroke weight, so icons sitting side by side look like a set. */
function Glyph(props: { readonly d: string; readonly size?: number }): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      width={props.size ?? 18}
      height={props.size ?? 18}
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d={props.d} />
    </svg>
  );
}

export const UndoIcon = (): JSX.Element => <Glyph d="M4 9h10a5 5 0 0 1 0 10h-5M4 9l4-4M4 9l4 4" />;

export const RedoIcon = (): JSX.Element => (
  <Glyph d="M20 9H10a5 5 0 0 0 0 10h5M20 9l-4-4M20 9l-4 4" />
);

export const FilesIcon = (): JSX.Element => (
  <Glyph d="M3 7.5A1.5 1.5 0 0 1 4.5 6h4L11 8.5h8.5A1.5 1.5 0 0 1 21 10v8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18z" />
);

export const SettingsIcon = (): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="3.2" />
    <path d="M12 2.8v2.4M12 18.8v2.4M4.5 7.5l2 1.2M17.5 15.3l2 1.2M4.5 16.5l2-1.2M17.5 8.7l2-1.2" />
  </svg>
);

/** Writes the current result back into the workspace, still editable afterwards. */
export const SaveIcon = (): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M5 4.5h10.5L19.5 8.5V18a1.5 1.5 0 0 1-1.5 1.5H5A1.5 1.5 0 0 1 3.5 18V6A1.5 1.5 0 0 1 5 4.5z" />
    <path d="M8 4.5v5h7v-5M7.5 19.5v-5h9v5" />
  </svg>
);

export const ExportIcon = (): JSX.Element => (
  <Glyph d="M12 3.5v10.5M12 3.5 8 7.5M12 3.5l4 4M4.5 15v3.5A1.5 1.5 0 0 0 6 20h12a1.5 1.5 0 0 0 1.5-1.5V15" />
);
